var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4799 17.02H28.5999C29.0399 17.02 29.3399 17.46 29.1899 17.87C28.5299 19.62 26.5699 22.19 22.0399 22.19C17.5099 22.19 15.5499 19.62 14.8899 17.87C14.7299 17.46 15.0399 17.02 15.4799 17.02Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9902 15.5301C23.8293 15.5301 25.3202 14.0392 25.3202 12.2001C25.3202 10.361 23.8293 8.87012 21.9902 8.87012C20.151 8.87012 18.6602 10.361 18.6602 12.2001C18.6602 14.0392 20.151 15.5301 21.9902 15.5301Z",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88977 18.54H22.4698C23.0898 18.54 23.5198 19.16 23.2998 19.75C22.3698 22.23 19.5898 25.86 13.1798 25.86C6.76977 25.86 3.98977 22.22 3.05977 19.74C2.83977 19.16 3.26977 18.53 3.88977 18.53V18.54Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1001 16.42C15.7014 16.42 17.8101 14.3113 17.8101 11.71C17.8101 9.10874 15.7014 7 13.1001 7C10.4989 7 8.39014 9.10874 8.39014 11.71C8.39014 14.3113 10.4989 16.42 13.1001 16.42Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/Perfil.d1e114673bb0e8c740fc975765df5a33.svg";
export { ForwardRef as ReactComponent };